/*
 * Copyright (c) 2025 curryfirm.com
 */

import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth.js';
import { auth } from '../../services/firebase.js';
import {
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    signOut,
} from 'firebase/auth';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

const AuthForm = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isSignUp, setIsSignUp] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            if (isSignUp) {
                await createUserWithEmailAndPassword(auth, email, password);
            } else {
                await signInWithEmailAndPassword(auth, email, password);
            }
            setEmail('');
            setPassword('');
        } catch (err) {
            setError(err.message);
        }
    };

    const handleSignOut = async () => {
        await signOut(auth);
    };

    // Get user from global source.
    const { user } = useAuth();

    return (
        <Box maxWidth={400} mx="auto" my={4}>
            <Paper elevation={3} sx={{ p: 3 }}>
                {user ? (
                    <Stack spacing={2} alignItems="center">
                        <Typography variant="h5">Welcome!</Typography>
                        <Typography>Signed in as: <b>{user.email}</b></Typography>
                        <Button variant="contained" color="primary" onClick={handleSignOut}>
                            Sign Out
                        </Button>
                    </Stack>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <Stack spacing={2}>
                            <Typography variant="h5" align="center" gutterBottom>
                                {isSignUp ? 'Sign Up' : 'Sign In'}
                            </Typography>
                            <TextField
                                label="Email"
                                type="email"
                                value={email}
                                fullWidth
                                required
                                onChange={e => setEmail(e.target.value)}
                            />
                            <TextField
                                label="Password"
                                type="password"
                                value={password}
                                fullWidth
                                required
                                minLength={6}
                                onChange={e => setPassword(e.target.value)}
                            />
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                            >
                                {isSignUp ? 'Create Account' : 'Sign In'}
                            </Button>
                            <Button
                                type="button"
                                color="secondary"
                                fullWidth
                                onClick={() => setIsSignUp(!isSignUp)}
                            >
                                {isSignUp ? 'Already have an account? Sign In' : "Don't have an account? Sign Up"}
                            </Button>
                            {error && <Alert severity="error">{error}</Alert>}
                        </Stack>
                    </form>
                )}
            </Paper>
        </Box>
    );
};

export default AuthForm;
